var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadSliderRound3 = function SvgFadSliderRound3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 226c13.27 0 25.936-2.584 37.994-7.752 12.059-5.168 22.49-12.154 31.295-20.959 8.805-8.805 15.791-19.236 20.959-31.295C223.416 153.936 226 141.271 226 128c0-13.27-2.584-25.936-7.752-37.994-5.168-12.059-12.154-22.49-20.959-31.295-8.805-8.805-19.236-15.791-31.295-20.959C153.936 32.584 141.271 30 128 30c-13.27 0-25.936 2.584-37.994 7.752-12.059 5.168-22.49 12.154-31.295 20.959-8.805 8.805-15.791 19.236-20.959 31.295C32.584 102.064 30 114.729 30 128c0 13.27 2.584 25.936 7.752 37.994 5.168 12.059 12.154 22.49 20.959 31.295 8.805 8.805 19.236 15.791 31.295 20.959C102.064 223.416 114.729 226 128 226z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 127.753,
    cy: 127.5,
    rx: 90.594,
    ry: 90.758
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.302 131.704c-4.443-4.699-7.652-10.634-8.887-17.31-1.234-6.678-.987-13.355.988-19.537-4.197-8.656-10.121-16.322-17.527-22.752-6.418.495-13.083-.741-19.007-3.71-6.171-3.214-11.108-7.665-14.564-12.859-9.627-1.978-19.501-2.225-28.635-.494-3.456 5.44-8.64 9.644-14.811 12.612-6.171 2.968-12.836 3.957-19.254 3.215-7.406 5.935-13.577 13.601-18.267 22.257 1.728 6.182 2.221 12.86.74 19.536-1.48 6.677-4.937 12.365-9.627 17.064.247 9.644 2.222 19.289 5.925 27.944 5.924 2.473 11.355 6.183 15.551 11.87 4.197 5.441 6.665 11.87 7.652 18.053 7.653 5.688 16.293 10.14 25.673 12.86 5.43-3.215 11.849-4.946 18.76-4.946 6.912 0 13.33 1.978 18.761 5.44 9.38-2.225 18.267-6.43 25.92-12.117.987-6.43 3.455-12.365 7.899-17.806 4.443-5.44 9.874-9.15 16.045-11.375 1.975-4.204 3.456-8.903 4.69-13.602 1.234-4.698 1.728-9.644 1.975-14.343z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.024 139.645c6.625-27.292-10.17-54.798-37.51-61.435-27.343-6.637-54.878 10.108-61.503 37.4-6.625 27.292 10.169 54.798 37.51 61.435 27.342 6.637 54.878-10.108 61.503-37.4z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000",
    cx: 128.5,
    cy: 96,
    rx: 14.5,
    ry: 14
  }))));
};
export { SvgFadSliderRound3 as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-slider-round-3.b965a575.svg";